import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import { ResizeObserver as PolyfillObserver } from '@juggle/resize-observer';
import { v4 } from 'uuid';

// Utils
import { zIndex } from '@utils/constants';
import { NotificationType } from '.';

// UI
import { NotificationCard } from './notification-card';
const weakMap: WeakMap<object, string> = new WeakMap();
const keygen = (obj: object): string => {
  // Find or create and return UUID
  const key = weakMap.get(obj);
  if (key) return key;else {
    weakMap.set(obj, v4());
    return weakMap.get(obj)!;
  }
};
export type NotificationPayload = {
  uniqueId: string;
  message?: string;
  timeout?: number;
  title: string;
  type: NotificationType;
};
export const NotificationOverlay: React.FC<{
  markAllForRemoval?: boolean;
  notifications: NotificationPayload[];
  removeNotification: (notificationId: string) => void;
}> = t0 => {
  const $ = _c(16);
  const {
    markAllForRemoval,
    notifications,
    removeNotification
  } = t0;
  const [documentHeight, setDocumentHeight] = React.useState(0);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const rootDiv = document.getElementById("__next");
      let resizeObserver;
      if (rootDiv) {
        const ResizeObserver = window.ResizeObserver || PolyfillObserver;
        resizeObserver = new ResizeObserver(() => setDocumentHeight(rootDiv.getBoundingClientRect().bottom));
        resizeObserver.observe(rootDiv);
      }
      return () => resizeObserver && resizeObserver.disconnect();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  React.useEffect(t1, t2);
  if (!notifications.length) {
    return null;
  }
  let t3;
  if ($[2] !== documentHeight) {
    t3 = {
      height: documentHeight,
      zIndex: zIndex.dropdown
    };
    $[2] = documentHeight;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== markAllForRemoval || $[5] !== notifications || $[6] !== removeNotification) {
    let t5;
    if ($[8] !== markAllForRemoval || $[9] !== removeNotification) {
      t5 = notification => <NotificationCard key={keygen(notification)} markForRemoval={markAllForRemoval} uniqueId={notification.uniqueId} message={notification.message} timeout={notification.timeout} title={notification.title} type={notification.type} removeNotification={removeNotification} />;
      $[8] = markAllForRemoval;
      $[9] = removeNotification;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = notifications.map(t5);
    $[4] = markAllForRemoval;
    $[5] = notifications;
    $[6] = removeNotification;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div aria-live="assertive" className="bottom-6 md:top-20 fixed left-0 right-0 flex flex-row mx-auto md:sticky md:justify-end"><div className="flex flex-col-reverse items-center px-2 w-full space-y-2 space-y-reverse md:flex-col md:items-end md:px-0 md:space-y-2"><>{t4}</></div></div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div className="md:top-20 absolute w-full pointer-events-none md:px-8" style={t3}>{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};